import React, { PropTypes } from 'react';
import classNames from 'classnames';

import Loader from 'AppComponents/Loader';

import '../../styles.scss';


const ReviewList = ({ loading, children }) => (
  <ul className={classNames('review-list', { loading })} styleName='review-list'>

    <li
      key='loader'
      className='loading'
      styleName='loading-item'
    >
      <Loader />
    </li>

    { children }

  </ul>
);

ReviewList.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
};

ReviewList.defaultProps = {
  children: null,
  loading: false,
};

export default ReviewList;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Reviews/components/ReviewList/index.jsx